const CALENDAR_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

/**
 * Serialize a user-selected civil date without converting it through UTC.
 *
 * Birth dates, expiry dates, and date filters are calendar values, not
 * instants. Date#toISOString can move them to another day in some time zones.
 */
export function toCalendarDate(value: Date): string {
  return [
    value.getFullYear(),
    pad(value.getMonth() + 1),
    pad(value.getDate()),
  ].join("-");
}

/**
 * Parse the calendar portion of an API value in local civil time.
 *
 * `new Date("YYYY-MM-DD")` is deliberately avoided because JavaScript treats
 * that form as UTC and western time zones may then display the prior day.
 */
export function fromCalendarDate(value?: string | null): Date | null {
  if (!value) return null;
  const match = CALENDAR_DATE_PATTERN.exec(value);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(year, month - 1, day);

  return parsed.getFullYear() === year &&
    parsed.getMonth() === month - 1 &&
    parsed.getDate() === day
    ? parsed
    : null;
}

export function todayCalendarDate(): string {
  return toCalendarDate(new Date());
}

export function formatCalendarDate(
  value?: string | null,
  locale?: string | string[],
): string {
  const parsed = fromCalendarDate(value);
  return parsed
    ? new Intl.DateTimeFormat(locale).format(parsed)
    : value?.trim() || "—";
}
